import React from "react";
import { Card, Col, Row, Tab } from "react-bootstrap";
import { User } from "../../../../context/AuthContext";
import { formatRoles } from "../../../../shared/utils/functions";
import { useTranslation } from "react-i18next";

const ProfileOverview = ({ user }: { user: User }) => {
    const { t } = useTranslation(); // Initialize translation hook

    return (
        <React.Fragment>
            <Tab.Pane eventKey="ProfileOverview" className="fade" id="user-set-profile" role="tabpanel">
                <Card>
                    <Card.Header>
                        <h5>{t('user.personalDetails')}</h5>
                    </Card.Header>
                    <Card.Body>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item px-0 pt-0">
                                <Row>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.fullName')}</p>
                                        <p className="mb-0">{user?.firstName + ' ' + user?.lastName}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.roles')}</p>
                                        <p className="mb-0">{user?.roles && formatRoles(user?.roles as any)}</p>
                                    </Col>
                                </Row>
                            </li>
                            <li className="list-group-item px-0">
                                <Row>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.phone')}</p>
                                        <p className="mb-0">{user?.contact?.phone}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.city')}</p>
                                        <p className="mb-0">{user?.contact?.city}</p>
                                    </Col>
                                </Row>
                            </li>
                            <li className="list-group-item px-0">
                                <Row>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.email')}</p>
                                        <p className="mb-0">{user?.email}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.zipCode')}</p>
                                        <p className="mb-0">{user?.contact?.zip}</p>
                                    </Col>
                                </Row>
                            </li>
                            <li className="list-group-item px-0 pb-0">
                                <Row>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.address')}</p>
                                        <p className="mb-0">{user?.contact?.address}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="mb-1 text-muted">{t('user.status')}</p>
                                        <p className="mb-0">{user?.isActive ? t('user.active') : t('user.inactive')}</p>
                                    </Col>
                                </Row>
                            </li>
                        </ul>
                    </Card.Body>
                </Card>
            </Tab.Pane>
        </React.Fragment>
    );
};

export default ProfileOverview;